/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateLinearAcceleratorDtoSourceAxisDistance } from './CreateLinearAcceleratorDtoSourceAxisDistance';
import {
    CreateLinearAcceleratorDtoSourceAxisDistanceFromJSON,
    CreateLinearAcceleratorDtoSourceAxisDistanceFromJSONTyped,
    CreateLinearAcceleratorDtoSourceAxisDistanceToJSON,
} from './CreateLinearAcceleratorDtoSourceAxisDistance';
import type { CreateOtherMvTherapyMachineDtoImageLocation } from './CreateOtherMvTherapyMachineDtoImageLocation';
import {
    CreateOtherMvTherapyMachineDtoImageLocationFromJSON,
    CreateOtherMvTherapyMachineDtoImageLocationFromJSONTyped,
    CreateOtherMvTherapyMachineDtoImageLocationToJSON,
} from './CreateOtherMvTherapyMachineDtoImageLocation';
import type { CreateOtherMvTherapyMachineDtoPtw100AreaName } from './CreateOtherMvTherapyMachineDtoPtw100AreaName';
import {
    CreateOtherMvTherapyMachineDtoPtw100AreaNameFromJSON,
    CreateOtherMvTherapyMachineDtoPtw100AreaNameFromJSONTyped,
    CreateOtherMvTherapyMachineDtoPtw100AreaNameToJSON,
} from './CreateOtherMvTherapyMachineDtoPtw100AreaName';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { MedicalSystemBeamLimitingDeviceType } from './MedicalSystemBeamLimitingDeviceType';
import {
    MedicalSystemBeamLimitingDeviceTypeFromJSON,
    MedicalSystemBeamLimitingDeviceTypeFromJSONTyped,
    MedicalSystemBeamLimitingDeviceTypeToJSON,
} from './MedicalSystemBeamLimitingDeviceType';
import type { MedicalSystemBeamProduction } from './MedicalSystemBeamProduction';
import {
    MedicalSystemBeamProductionFromJSON,
    MedicalSystemBeamProductionFromJSONTyped,
    MedicalSystemBeamProductionToJSON,
} from './MedicalSystemBeamProduction';
import type { MedicalSystemSubCategory } from './MedicalSystemSubCategory';
import {
    MedicalSystemSubCategoryFromJSON,
    MedicalSystemSubCategoryFromJSONTyped,
    MedicalSystemSubCategoryToJSON,
} from './MedicalSystemSubCategory';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';

/**
 * 
 * @export
 * @interface CreateOtherMvTherapyMachineDto
 */
export interface CreateOtherMvTherapyMachineDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    description?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {MedicalSystemSubCategory}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    subCategory: MedicalSystemSubCategory;
    /**
     * 
     * @type {MedicalSystemBeamLimitingDeviceType}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    beamLimitingDeviceType?: MedicalSystemBeamLimitingDeviceType;
    /**
     * 
     * @type {MedicalSystemBeamProduction}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    beamProduction?: MedicalSystemBeamProduction;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {CreateLinearAcceleratorDtoSourceAxisDistance}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    sourceAxisDistance?: CreateLinearAcceleratorDtoSourceAxisDistance | null;
    /**
     * 
     * @type {CreateOtherMvTherapyMachineDtoImageLocation}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    imageLocation?: CreateOtherMvTherapyMachineDtoImageLocation | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    externalRtSystemId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    externalFileSystemPath?: string | null;
    /**
     * 
     * @type {CreateOtherMvTherapyMachineDtoPtw100AreaName}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    ptw100AreaName?: CreateOtherMvTherapyMachineDtoPtw100AreaName | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherMvTherapyMachineDto
     */
    $type?: CreateOtherMvTherapyMachineDtoTypeEnum;
}


/**
 * @export
 */
export const CreateOtherMvTherapyMachineDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoDescriptionsCreateOtherMvTherapyMachineDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateOtherMvTherapyMachineDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateOtherMvTherapyMachineDtoTypeEnum = typeof CreateOtherMvTherapyMachineDtoTypeEnum[keyof typeof CreateOtherMvTherapyMachineDtoTypeEnum];


/**
 * Check if a given object implements the CreateOtherMvTherapyMachineDto interface.
 */
export function instanceOfCreateOtherMvTherapyMachineDto(value?: unknown): value is CreateOtherMvTherapyMachineDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateOtherMvTherapyMachineDtoTypeEnum)[0];
}

export function CreateOtherMvTherapyMachineDtoFromJSON(json: any): CreateOtherMvTherapyMachineDto {
    return CreateOtherMvTherapyMachineDtoFromJSONTyped(json, false);
}

export function CreateOtherMvTherapyMachineDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOtherMvTherapyMachineDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': !exists(json, 'subModel') ? undefined : json['subModel'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'isArchived': !exists(json, 'isArchived') ? undefined : json['isArchived'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'typeSpecification': !exists(json, 'typeSpecification') ? undefined : json['typeSpecification'],
        'subCategory': MedicalSystemSubCategoryFromJSON(json['subCategory']),
        'beamLimitingDeviceType': !exists(json, 'beamLimitingDeviceType') ? undefined : MedicalSystemBeamLimitingDeviceTypeFromJSON(json['beamLimitingDeviceType']),
        'beamProduction': !exists(json, 'beamProduction') ? undefined : MedicalSystemBeamProductionFromJSON(json['beamProduction']),
        'serialNumber': !exists(json, 'serialNumber') ? undefined : json['serialNumber'],
        'sourceAxisDistance': !exists(json, 'sourceAxisDistance') ? undefined : CreateLinearAcceleratorDtoSourceAxisDistanceFromJSON(json['sourceAxisDistance']),
        'imageLocation': !exists(json, 'imageLocation') ? undefined : CreateOtherMvTherapyMachineDtoImageLocationFromJSON(json['imageLocation']),
        'externalRtSystemId': !exists(json, 'externalRtSystemId') ? undefined : json['externalRtSystemId'],
        'externalFileSystemPath': !exists(json, 'externalFileSystemPath') ? undefined : json['externalFileSystemPath'],
        'ptw100AreaName': !exists(json, 'ptw100AreaName') ? undefined : CreateOtherMvTherapyMachineDtoPtw100AreaNameFromJSON(json['ptw100AreaName']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateOtherMvTherapyMachineDtoToJSON(value?: CreateOtherMvTherapyMachineDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value.name,
        'description': value.description,
        'category': RtSystemCategoryToJSON(value.category),
        'manufacturer': RtSystemManufacturerToJSON(value.manufacturer),
        'model': value.model,
        'subModel': value.subModel,
        'imageId': value.imageId,
        'isAvailable': value.isAvailable,
        'isArchived': value.isArchived,
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'typeSpecification': value.typeSpecification,
        'subCategory': MedicalSystemSubCategoryToJSON(value.subCategory),
        'beamLimitingDeviceType': MedicalSystemBeamLimitingDeviceTypeToJSON(value.beamLimitingDeviceType),
        'beamProduction': MedicalSystemBeamProductionToJSON(value.beamProduction),
        'serialNumber': value.serialNumber,
        'sourceAxisDistance': CreateLinearAcceleratorDtoSourceAxisDistanceToJSON(value.sourceAxisDistance),
        'imageLocation': CreateOtherMvTherapyMachineDtoImageLocationToJSON(value.imageLocation),
        'externalRtSystemId': value.externalRtSystemId,
        'externalFileSystemPath': value.externalFileSystemPath,
        'ptw100AreaName': CreateOtherMvTherapyMachineDtoPtw100AreaNameToJSON(value.ptw100AreaName),
        '$type': value.$type,
    });
}

